exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-dropdown-profile-pic {\n  width: 100px;\n  border-radius: 100%; }\n\n.header-dropdown-toggle {\n  width: 100px;\n  border-radius: 100%;\n  background: none;\n  border: none;\n  margin-left: 15px;\n  margin-right: 15px; }\n\n.header-dropdown-header, .header-dropdown-item {\n  font-size: 18px; }\n\n.header-dropdown-item:hover {\n  color: #4ec8ed;\n  background-color: white;\n  text-decoration: none; }\n", ""]);

// exports
